import React from 'react';
import { map } from 'lodash';
import styled from 'styled-components';

const Letter = styled.span`
    width: 10px;
`;

const WordSkeletonContainer = styled.div`
    display: flex;
    ${Letter} {
        &:not(:first-child) {
            margin-left: 4px;
        }
    }
`;

const Word = styled.span`
    margin-right: 4px;
`;

export const WordSkeleton = ({
    word,
    showWord,
    className,
}: {
    word: string,
    className?: string,
    showWord: boolean,
}) => {
    return (
        <WordSkeletonContainer className={className}>
            <Word>Word:</Word>{' '}
            {map(word, (letter, idx) => {
                const hiddenLetter = letter === ' ' ? ' ' : '_';
                return <Letter key={idx}>{showWord ? letter : hiddenLetter}</Letter>;
            })}
        </WordSkeletonContainer>
    );
};
